module.exports = __webpack_public_path__ + "static/img/r-1-5-icon.4019521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/r-1-5-icon.png
// module id = +t2k
// module chunks = 0